/**
 *
 * @description: 西部利得
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'xbld';
const comein_channel = isBuild ? 'f131b15c-805d-4c8f-a07e-3e9561fe6333' : '4a73480c-18e6-4e0c-80b7-55565275de59';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'xbld';

// 西部利得Bridge类 - 使用默认实现
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
